import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=073211e8"
import script from "./landingpage.vue?vue&type=script&lang=js"
export * from "./landingpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports